"use client"

import { cn } from "@/lib/utils"

interface BorderBeamProps {
  className?: string
  size?: number
  duration?: number
  colorFrom?: string
  colorTo?: string
  borderWidth?: number
  reverse?: boolean
}

export const BorderBeam = ({
  className,
  size = 50,
  duration = 6,
  colorFrom = "#4F46E5",
  colorTo = "#9c40ff",
  borderWidth = 1.5,
}: BorderBeamProps) => {
  return (
    <div
      className={cn(
        "pointer-events-none absolute inset-0 rounded-[inherit]",
        className
      )}
    >
      {/* Animated beam element */}
      <div
        className="absolute rounded-[inherit]"
        style={{
          inset: 0,
          padding: `${borderWidth}px`,
          background: `linear-gradient(90deg, transparent, ${colorFrom}, ${colorTo}, transparent)`,
          backgroundSize: "50% 100%",
          backgroundRepeat: "no-repeat",
          WebkitMask: "linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)",
          WebkitMaskComposite: "xor",
          mask: "linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)",
          maskComposite: "exclude",
          animation: `border-beam-slide ${duration}s ease-in-out infinite`,
        }}
      />
    </div>
  )
}
